import { translateBlockValue, translateComponent } from 'i18n';
import {
    getInitialProjectsPivotGridColDefs,
    getProjectGridDimensions,
} from './helpers/pivotGrid';
import {
    ColDef,
    ValueFormatterParams,
    ValueGetterParams,
} from 'ag-grid-community';
import {
    INSCRIPTION_INVESTMENT_OPERATING,
    ORG_CHART_FINANCE_FIELD,
    SECTION_FIELD,
} from 'routes/BudgetModule/config/constants';
import { objectWithLabelFormatter } from 'ui/AgGridReact/formatters';
import { BudgetProposalT } from 'routes/BudgetModule/config/types';
import { ProjectWithInscriptionT } from 'routes/BudgetModule/components/BudgetProposal/Resource/Analyse/hooks/getProjectsWithInscriptions';

type Props = {
    amountRequestedField: string;
    integratedSoftwares: Set<string> | undefined;
    getDimensionColumn: (dimension: string) => ColDef;
    budgetProposal: BudgetProposalT;
    baseFilters: QueryFilterT[];
    onInscriptionsModalClosed: (arg1: void) => void;
};

const getInitialColDefs = ({
    amountRequestedField,
    integratedSoftwares,
    getDimensionColumn,
    budgetProposal,
    baseFilters,
    onInscriptionsModalClosed,
}: Props) => {
    const colDefs = [
        ...getInitialProjectsPivotGridColDefs(
            amountRequestedField,
            budgetProposal,
            baseFilters,
            onInscriptionsModalClosed,
        ),
        ...getProjectGridDimensions(integratedSoftwares).map(
            getDimensionColumn,
        ),
    ];
    return colDefs.map((c) => {
        const headerName = c?.field ? translateBlockValue(c.field, true) : '';
        if (c.field === ORG_CHART_FINANCE_FIELD) {
            return {
                ...c,
                headerName,
                valueFormatter: objectWithLabelFormatter,
            };
        }
        if (
            [SECTION_FIELD, INSCRIPTION_INVESTMENT_OPERATING].includes(c.field)
        ) {
            return {
                ...c,
                headerName,
                valueGetter: (
                    params: ValueGetterParams<ProjectWithInscriptionT>,
                ) => {
                    return (
                        params.data?.[SECTION_FIELD] ||
                        params.data?.[INSCRIPTION_INVESTMENT_OPERATING] ||
                        ''
                    );
                },
                valueFormatter: (
                    params: ValueFormatterParams<ProjectWithInscriptionT>,
                ) => {
                    return params.value === ''
                        ? translateComponent('cellar.blanks')
                        : translateBlockValue(params.value, true);
                },
            };
        }
        return {
            ...c,
            headerName,
        };
    });
};

export default getInitialColDefs;
